import { useMutation } from '@apollo/client'
import { EditVaccination, EditVaccinationVariables } from '../../types'
import { EDIT_VACCINATION } from './operations'

export const useEditVaccination = () =>
  useMutation<EditVaccination, EditVaccinationVariables>(EDIT_VACCINATION)
